/* unplugin-vue-components disabled */import script from "./ProductHighlight.vue?vue&type=script&lang=js"
export * from "./ProductHighlight.vue?vue&type=script&lang=js"

import "./ProductHighlight.vue?vue&type=style&index=0&id=e83da462&lang=scss"

const __exports__ = script;

export default __exports__